import React from "react";
import Pix from "../../components/acesso-rapido/pix/Pix";

export default function () {
  return <Pix />;
}
